import { Typography, type SxProps, type Theme } from '@mui/material';
import { useIntl } from 'react-intl';
import { useClinicalListsListPeople } from '~/backend/connector-next-api/connector-next-components';
import { useClinicalLists } from '../hooks';

/**
 * Says that the clinical tags and sites or the people a patient's care is
 * chosen from could not be loaded, so the names and choices built on them are
 * missing; renders nothing while they are loaded or still loading.
 */
export default function ConfigurationLoadFailure({
    sx,
}: {
    sx?: SxProps<Theme>;
}) {
    const intl = useIntl();
    const lists = useClinicalLists();
    const people = useClinicalListsListPeople({});
    // A read that failed after loading still holds what it loaded.
    if (!lists.isError && !(people.isError && people.data === undefined)) {
        return null;
    }
    return (
        <Typography variant="body2" color="error" role="alert" sx={sx}>
            {intl.formatMessage({ id: 'patientList.configuration.loadFailed' })}
        </Typography>
    );
}
